import { render, staticRenderFns } from "./SuggestAnalysisSampleDepthInputs.vue?vue&type=template&id=44912c84&scoped=true"
import script from "./SuggestAnalysisSampleDepthInputs.vue?vue&type=script&lang=js"
export * from "./SuggestAnalysisSampleDepthInputs.vue?vue&type=script&lang=js"
import style0 from "./SuggestAnalysisSampleDepthInputs.vue?vue&type=style&index=0&id=44912c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44912c84",
  null
  
)

export default component.exports